/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_S2_TitleInputs */

const en_mk_ctrl_s2_title = /** @type {(inputs: Mk_Ctrl_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public benchmark`)
};

const id_mk_ctrl_s2_title = /** @type {(inputs: Mk_Ctrl_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmark publik`)
};

/**
* | output |
* | --- |
* | "Public benchmark" |
*
* @param {Mk_Ctrl_S2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_s2_title = /** @type {((inputs?: Mk_Ctrl_S2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_S2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_s2_title(inputs)
	return en_mk_ctrl_s2_title(inputs)
});